import { render, staticRenderFns } from "./MenuSection.vue?vue&type=template&id=02782f50&"
import script from "./MenuSection.vue?vue&type=script&lang=js&"
export * from "./MenuSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports